export default "__VITE_ASSET__2a2b5958__"